import { Skeleton, Alert, Button } from '@revfluence/fresh';
import { Typography } from 'antd';
import React from 'react';
import Helmet from 'react-helmet';
import { useGetEmbeddedReportingItem } from '@frontend/app/hooks';
import { EmbedProvider } from '@frontend/app/types/globalTypes';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { toNumber } from 'lodash';
import styles from './ReportingDetailView.scss';
import { SupersetEmbed } from './SupersetEmbed';
// import { Header } from './components/Header';

const { Title } = Typography;

// Make sure that <tableau-viz> is accepted as a valid top-level DOM element in JSX/TSX without errors
declare global {
   
  namespace JSX {
    interface IntrinsicElements {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'tableau-viz': any;
    }
  }
}

interface IMatchParams {
  reportId: string;
}

export const ReportingDetailView: React.FC<React.PropsWithChildren<RouteComponentProps>> = () => {
  const { reportId } = useParams<IMatchParams>();
  const { data, loading, error, refetch } = useGetEmbeddedReportingItem(toNumber(reportId));

  console.log('data', data);

  if (loading) {
    // Return Skeleton if loading
    return <Skeleton active paragraph />;
  }

  if (!loading && error) {
    // Return error message if error
    return (
      <Alert
        action={
          <Button onClick={() => refetch()} size="small" type="ghost">
            Retry
          </Button>
        }
        message="Oops! Something went wrong fetching this report."
        showIcon
        type="error"
      />
    );
  }

  const item = data?.getEmbeddedReportingItemById;

  return (
    <div>
      <Title>{item?.name}</Title>
      {item?.provider === EmbedProvider.SUPERSET ? (
        !item?.host ? (
          <Alert message="This report is temporarily unavailable. Please try again." showIcon type="error" />
        ) : (
          <div className={styles.tableauContainer}>
            <SupersetEmbed
              embedUuid={item.embedUuid}
              host={item.host}
              fetchGuestToken={async () => {
                // Re-mint a fresh guest token on the SDK's demand (mount/expiry).
                const result = await refetch();
                const refreshed = result?.data?.getEmbeddedReportingItemById;
                if (!refreshed?.guestToken) {
                  throw new Error('Superset guest token unavailable');
                }
                return refreshed.guestToken;
              }}
            />
          </div>
        )
      ) : (
        <>
          <Helmet>
            <script
              async
              defer
              type="module"
              src="https://us-west-2b.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js"
            />
          </Helmet>
          <div className={styles.tableauContainer}>
            <tableau-viz
              id="tableau-viz"
              src={item?.url}
              hide-tabs
              toolbar="hidden"
              height="100%"
              token={item?.token}
            />
          </div>
        </>
      )}
    </div>
  );
};

ReportingDetailView.defaultProps = {};

ReportingDetailView.displayName = 'ReportingDetailView';

export default ReportingDetailView;
